// import components
import { Box, styled } from '@mui/material';

/** Label column plus one column per weekday, so every row lines up under the same day headers. */
const GRID_TEMPLATE = '240px repeat(7, minmax(140px, 1fr))';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  height: '100%',
  overflow: 'auto'
}));

export const Breadcrumb = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  paddingBottom: theme.spacing(1)
}));

export const Row = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: GRID_TEMPLATE,
  alignItems: 'stretch'
}));

export const DayHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  borderLeft: '1px solid',
  borderLeftColor: theme.palette.divider
}));

export const CareReceiverBand = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1),
  marginTop: theme.spacing(1),
  backgroundColor: theme.palette.grey[100],
  borderTop: '1px solid',
  borderTopColor: theme.palette.divider,
  fontWeight: 600
}));

/** The label column of a category or rule row. `indented` sets a rule apart from its category above. */
export const LabelCell = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'indented'
})<{ indented?: boolean }>(({ theme, indented }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  minWidth: 0,
  padding: theme.spacing(1),
  paddingLeft: indented ? theme.spacing(4) : theme.spacing(1)
}));

/** A weekday cell; `minWidth: 0` lets long appointment cards ellipsis rather than widen the column. */
export const DayCell = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  minWidth: 0,
  padding: theme.spacing(1),
  borderLeft: '1px solid',
  borderLeftColor: theme.palette.divider,
  borderTop: '1px solid',
  borderTopColor: theme.palette.divider
}));
